<div class="footer-row nar">
  <div class="nar-info">
    <span class="nar-message">{{ message }}</span>
  </div>
  <button class="action-btn primary" [routerLink]="['/notAvailableReason']">
    <i [nimbusIcon]="ICONS.EDIT" [iconWeight]="IconWeight.Regular"></i>
    <span class="action-text">{{ TranslationKeys.NotAvailableReasonFillOut | translate }}</span>
  </button>
</div>
